import React from 'react';

const backgroundClassByKey = {
	slate: 'bg-slate-100',
	sky: 'bg-sky-100',
	emerald: 'bg-emerald-100',
	amber: 'bg-amber-100',
	rose: 'bg-rose-100',
	white: 'bg-white',
};

function TitleWidget({ headerLabel, subHeaderLabel, backgroundColor }) {
	const colorKey = (backgroundColor || 'slate').trim().toLowerCase();
	const backgroundClass = backgroundClassByKey[colorKey] || backgroundClassByKey.slate;

	return (
		<div className={`flex h-full w-full flex-col items-center justify-center rounded-lg border border-slate-200/80 px-4 text-center ${backgroundClass}`}>
			<div className="max-w-full">
				<div className="break-words text-[20px] font-semibold leading-tight text-slate-800">
					{headerLabel || 'Title'}
				</div>
				{subHeaderLabel ? (
					<div className="mt-2 break-words text-[12px] text-slate-600">{subHeaderLabel}</div>
				) : null}
			</div>
		</div>
	);
}

export default TitleWidget;
